module.exports = __webpack_public_path__ + "img/couples-064.a1787db0.jpg";